import { useLazyFetch, useLazyPost } from "../utils/apiclient";
import { tgdmUrl } from "../utils/urls";
import { getHeaders } from "../utils/apiclient";

export const useListAllControlPlanes = (deploymentStage) => {
  return useLazyFetch(
    `${tgdmUrl}/apps/tessellgcp/deployments/${deploymentStage}/control-planes`,
    {
      headers: { ...getHeaders(), Action: "LIST_ALL" },
    }
  );
};

export const useUpgradeControlPlane = (deploymentStage, controlPlane) => {
  return useLazyPost(
    `${tgdmUrl}/apps/tessellgcp/deployments/${deploymentStage}/control-planes/${controlPlane}`,
    {
      headers: { ...getHeaders(), Action: "UPGRADE" },
      method: "PUT",
    }
  );
};
